/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

export enum ToursOverviewTab {
  AllTours,
  DeliveryTours,
  MaintenanceTours,
  ServiceTours,
  Appointments
}
